<div class="app-alert display-none display-flex"
    *ngIf="forgotPasswordVisibility">
    <div class="app-alert__box bg-light box-shadow app-alert__box--padding"
        data-testid="app-old-alert">
        <div class="app-alert__message app-alert__message--block font-14 cursor-default">
            {{ subtitles.setSubtitle(1853) }} {{ subtitles.setSubtitle(1931) }}
        </div>
        <input type="text"
               [(ngModel)]="forgotContact"
               class="border-input app-alert__input"
               placeholder="{{ subtitles.setSubtitle(1110) }}" />
        <div class="app-alert__buttons-box">
            <button class="app-alert__button bg-cancel color-light font-bold font-14 cursor-pointer"
                    (click)="goLogin()">
                {{ subtitles.setSubtitle(71) }}
            </button>
            <button class="app-alert__button bg-ok color-light font-bold font-14 cursor-pointer"
                    autofocus
                    (click)="sendPasswordEmail()">
                {{ subtitles.setSubtitle(1952) }}
            </button>
        </div>
    </div>
</div>
